import { sortContentNodeBlocks } from 'common/builder/components/chart/FlowChart/lib/utils/sortContentNodeBlocks'
import { FlowChartBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'

export const getContentNodeBlocksList = ({
  blockIds,
  blocksMap,
}: {
  blockIds: string[]
  blocksMap: Record<string, FlowChartBlock>
}): FlowChartBlock[] => {
  return blockIds
    .map((blockId) => blocksMap[blockId])
    .filter((block) => Boolean(block))
    .sort(sortContentNodeBlocks)
}
